<template>
    <div>
        <div class="peribox">
            <div class="perititle">
                <div>Delivery Agent Lead</div>
                <div class="periicons">
                    <i class="far fa-sync-alt" @click="refresh"></i>
                </div>
            </div>
            <table class="peritable">
                <tbody>
                <tr>
                    <th>Column</th>
                    <th>Lead</th>
                </tr>
                <tr v-for="c in columns">
                    <th>{{ c }}</th>
                    <td>{{ row ? row[c] : '' }}</td>
                </tr>
                <tr v-for="c in fields">
                    <th>{{ c.key }}</th>
                    <td>{{ c.value }}</td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="peribox">
            <div class="perititle">
                <div>Custom Questions</div>
                <div class="periicons">
                    <i class="far fa-sync-alt" @click="refresh"></i>
                </div>
            </div>
            <table class="peritable">
                <tbody>
                <tr>
                    <th>Id</th>
                    <th>Question</th>
                    <th>Answer</th>
                </tr>
                <tr v-for="c in questions">
                    <td>{{ c.question_id }}</td>
                    <td>{{ c.question }}</td>
                    <td>{{ c.answer }}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'app_id',
        'delivery_lead_id'
    ],
    data() {
        let columns = [
            'id',
            'date',
            'application_id',
            'employer_id',
            'campaign_id',
            'job_id',
            'agent',
            'data',
            'referrer',
            'cdl_xp',
            'cdl_xp_text',
            'is_owner_operator',
            'is_student',
            'source',
            'name',
            'first_name',
            'middle_name',
            'last_name',
            'cdl_a',
            'cdl_b',
            'cdl_c',
            'phone',
            'email',
            'city',
            'state',
            'state_code',
            'zip_code'
        ];
        return {
            row: null,
            fields: [],
            questions: [],
            columns: columns
        };
    },
    methods: {
        refresh() {
            axios.get(url(`app/test/app/${this.app_id}/delivery-agent-lead/${this.delivery_lead_id}`))
                .then((response) => {
                    this.row = response.data.row;
                    this.fields = response.data.fields;
                    this.questions = response.data.questions;
                });
        }
    },
    mounted() {
        this.refresh();
    }
}
</script>

<style>
</style>
